import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../../services/LoadingService";
import {StateService} from "../../../services/StateService";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {ActivatedRoute, Router} from "@angular/router";
import {PageTitleService} from "../../../services/PageTitle";
import {Session} from "../../../services/Session";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ToastService} from "../../../services/Toast.service";
import {TrackerService} from "../../../services/taskTracker.service";
import {TrackerPaginatedTableComponent} from "../../../tables/tracker-paginated-table/tracker-paginated-table.component";
import {PostWrapperComponent} from "../../../posts/post-wrapper/post-wrapper.component";
import {CheckListComponent} from "../../../check-list/check-list.component";
import {TaskTodosComponent} from "../task-todos/task-todos.component";
import {v4 as uuid} from 'uuid';
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import {TpiqSelectDropdownComponent} from "../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {FileUploader, FileUploaderOptions} from "ng2-file-upload";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {TpiqCustomDatepicker} from "../../../directives/tpiq-custom-datepicker";
import { environment } from '../../../../environments/environment';

declare let _: any;

@Component({
  selector: 'app-task-single-page',
  standalone: true,
  imports: [CommonModule, FormsModule, TrackerPaginatedTableComponent, PostWrapperComponent, CheckListComponent, TaskTodosComponent,
  FroalaEditorModule, TpiqSelectDropdownComponent, TpiqCustomDatepicker, FroalaViewModule, TpiqCustomDatepicker],
  templateUrl: './task-single-page.component.html',
  styleUrl: './task-single-page.component.scss'
})
export class TaskSinglePageComponent implements OnInit, OnDestroy {
  org: string;
  user = '';
  tableData: any = {};
  hasTasks = false;
  prevSubscription: any;
  routeSub: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  checklistData: any;
  viewChecklist = false;
  nextIndex = 0;
  reveal: any = {
    addTodo: false,
    timer: false,
    status_timer: false,
    engagementEmailResend: false,
    checklist: false,
    engSettings: false,
    newTask: false,
    workProjection: false,
    depreciatedTimeZone: false,
    emailTracker: false,
    engagementHistory: false
  };
  tasksSort: any = {};
  searchString: string;
  currentPeriod: string;
  trackerData: Array<any> = [];
  trackerView = 'self_tasks';
  users: Array<any> = [];
  preferredStatuses: Array<any> = [
    {id: 'Assigned', name: 'Assigned'},
    {id: 'Blocked', name: 'Blocked'},
    {id: 'In Progress', name: 'In Progress'},
    {id: 'Review', name: 'Review'},
    {id: 'Done', name: 'Done'},
  ];
  priorities: Array<any> = [{id: 'High', name: 'High', badge: 'H'}, {
    id: 'Medium',
    name: 'Medium',
    badge: 'M'
  }, {id: 'Low', name: 'Low', badge: 'L'}];
  taskSinglePostData: any;
  showTodos = false;
  singlePageviewChecklist = false;
  trackerName: any;
  resetTodoTable = true;
  taskId: string;
  channelId = '';
  channelType = '';
  refreshTracker = true;
  currentTrackerRecurringType: any;
  isLoading = false;
  isTaxPlanningTask = false;
  taskPostId = '';
  singlePageTaskData: any;
  taskMetaData: any;
  todoData: any = {};
  taxStrategyTodos: Array<any> = [];

  todoAssignees: Array<any> = [];
  todoTitle = '';
  todoDesc = '';
  todoDuedate = '';
  todoPriority = 'Medium';
  todoId: any;
  attachments: Array<any> = [];
  selectedTaxStrategyTodo = '';
  todoDescriptionEditorOptions: any = {
    heightMin: 100,
    heightMax: 120,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent', 'lineHeight'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Write your description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events: {},
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    imageUploadRemoteUrls: false,
  };
  dateFormat: string;
  uploader: FileUploader;
  document: any;
  constructor(private titleService: PageTitleService, private loadingService: LoadingService,
              private _router: Router, private stateService: StateService, private switchBoard: SwitchBoard,
              private _route: ActivatedRoute, private changeDetectorRef: ChangeDetectorRef,
              private toastService: ToastService, private trackerService: TrackerService,
              private taxStrategyServices: ManageTaxStrategiesServices) {}

  ngOnInit() {
    const base = this;
    this.dateFormat = 'MM/DD/YYYY';
    this.org = Session.getOrg();
    this.user = Session.getUser().id || '';
    if (this.users && this.users.length == 0) {
      this.getActiveUsers();
    } else {
      this.formatUsersData();
    }
    this.titleService.setPageTitle('Tracker');
    this.switchBoard.onPageChangeListener.next({});
    this.prevSubscription = this.switchBoard.onClickPrev.subscribe(title => {
      const prevState = this.stateService.getPrevState();
      if (prevState && prevState.key === 'TAX_STRATEGY') {
        setTimeout(() => {
          this._router.navigate([prevState.url], {queryParams: {fromTaskPage: true}});
        });
      }
    });


    this.routeSub = this._route.params.subscribe(params => {
      this.refreshTracker = true;
      this.taskId = params.taskId;
      this.channelId = params.channelId;
      this.channelType = params.channelType;
      this.currentTrackerRecurringType = '';
      if (this.taskId) {
        this.trackerView = 'info';
        const obj = {
          clientId: this.channelId
        };
        this.loadingService.triggerLoadingEvent(true);

        base.setTrackerTaskData();
        base.getTaskMetadata();
      }
    });

    this.setFileUploader();
  }

  getActiveUsers() {
    this.trackerService.getUsers().subscribe(response => {
      this.users = response.users;
      _.forEach(this.users, function(user) {
        user.name = user.firstName + ' ' + user.lastName;
        user.email = user.id;
      });
      Session.setUsers(this.users);
    }, error => {

    });
  }

  getTaskMetadata() {
    this.resetTodoTable = false;
    this.loadingService.triggerLoadingEvent(true);
    this.trackerService.getTaskPageMetaData(this.taskId).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.taskMetaData = response;
      this.checklistData = response.checklist;
      this.singlePageviewChecklist = true;
      this.todoData.toDosList = response.todos ? response.todos : [];
      this.taxStrategyTodos = response.clientTodos || [];
      this.resetTodoTable = true;
    }, error => {
      this.isLoading = false;
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  setTrackerTaskData() {
    this.loadingService.triggerLoadingEvent(true);
    this.trackerService.getTaskTracker(this.taskId).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.isLoading = false;
      this.isTaxPlanningTask = true;
      this.trackerData = [response];
      if (this.trackerData.length > 0) {
        this.taskPostId = this.trackerData[0].postId;
      }
      this.taskSinglePostData = this.trackerData[0].taskPost;
      this.trackerName = this.trackerData[0].title;
      this.titleService.setPageTitle(this.trackerData[0].customerName);
      const tasks = [response];
      this.singlePageTaskData = tasks;
      this.loadingService.triggerLoadingEvent(false);
      this.buildBucketTables(tasks, false);
      this.showTodos = true;
    }, error => {
      this.isLoading = false;
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  buildBucketTables(tasks, refreshStatus) {
    this.buildItemsTableData(tasks, refreshStatus);
  }

  buildItemsTableData(data, refreshTable?) {
    const base = this;
    this.tableData.options = {
      height: this.getTableHeaght(),
      selectorString: 'taskId',
      showSearch: false,
      searchString: this.searchString
    };
    this.tableData.columns = [];
    this.tableData.columns.push({
      name: 'customerName',
      title: 'Client',
      type: 'html',
      classes: 'pointer zero-overflow',
      sortable: false
    });
    this.tableData.columns.push({
      name: 'status',
      title: 'Status',
      classes: 'pointer input-search',
      type: 'badge-input-search',
      'status-col': true,
      editable: true,
      displayName: 'name',
      full_name: 'name',
      background: 'colorCode',
      'multi-dropdown': false,
      data: base.preferredStatuses,
      placeholder: '',
      sortable: false,
      moveStatus: true
    });
    this.tableData.columns.push({
      name: 'taskAssignees',
      title: 'Assigned',
      type: 'badge-input-search',
      displayName: 'badge',
      full_name: 'name',
      background: 'colorCode',
      'multi-dropdown': true,
      data: base.users,
      placeholder: '',
      classes: 'input-search pointer',
      sortable: false
    });
    this.tableData.columns.push({
      name: 'dueDate',
      title: 'Due Date',
      type: 'date',
      format: 'MM/DD/YYYY',
      placeholder: 'MM/DD/YYYY',
      classes: 'input-date pointer',
      initAlways: true,
      sortable: false
    });
    this.tableData.columns.push({
      name: 'priority',
      title: 'Priority',
      type: 'badge-input-search',
      displayName: 'badge',
      full_name: 'name',
      background: 'colorCode',
      'multi-dropdown': false,
      data: base.priorities,
      placeholder: '',
      classes: 'input-search pointer',
      sortable: false
    });
    this.tableData.columns.push({
      name: 'relatedParty',
      title: 'Related Party',
      type: 'normal',
      sortable: false
    });
    this.tableData.columns.push({
      name: 'actions',
      title: '',
      type: 'html',
      classes: 'actions-class',
      sortable: false
    });

    if (refreshTable) {
      this.tableData.rows = [];
    } else {
      this.tableData.rows = this.tableData.rows || [];
    }
    const rows = base.tableData.rows || [];
    data.forEach(function(task) {
      const row = base.createTableRow(task);
      rows.push(row);
    });
    this.tableData = {...this.tableData, rows};
    this.handleSortOrder(this.tasksSort, this.tableData.columns);
    if (refreshTable) {
      this.hasTasks = false;
    }
    this.loadingService.triggerLoadingEvent(false);

    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
    if (base.tableData.rows.length > 0) {
      base.isLoading = false;
    } else {
      base.isLoading = false;
    }
    base.hasTasks = true;
  }

  handleSortOrder(tasksSortOrder, columns) {
    _.each(columns, function(column) {
      column.sortType = tasksSortOrder[column.name];
    });
  }

  formatUsersData() {
    if (this.users && this.users.length > 0){
      _.each(this.users, function(user){
        user['name'] = user.firstName + ' ' + user.lastName;
        user['email'] = user.id;

      });
    }
  }

  getTableHeaght() {
    let heightStr = '66vh';
    switch (this.trackerView) {
      case 'user':
        heightStr = '78vh';
        break;
      case 'info':
        heightStr = 'inherited';
        break;
    }
    return heightStr;
  }

  ngOnDestroy() {
    this.prevSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleTasksTableAction($event) {
    const action = $event.action;
    let company: any;
    if (action == 'edit') {
    } else if (action == 'checklist') {
      this.openChecklistDailog($event);
    }
  }

  openChecklistDailog(data) {
    const base = this;
    base.checklistData = {};
    setTimeout(function() {
      base.checklistData = data;
      base.viewChecklist = true;
      base.reveal = {...base.reveal, checklist: true};
      base.changeDetectorRef.detectChanges();
    });
  }

  sortByColumn(obj) {
    this.nextIndex = 0;
    this.sortTasks(obj);
  }

  sortTasks(obj) {
  }

  handleScroll(event) {

  }

  optionSelected($event) {
    let data = _.find(this.trackerData, {id: $event.row.id});
    const duplicateCopy = _.cloneDeep(this.trackerData);
    const column = _.find(this.tableData.columns, {name: $event.column});
    if ($event.column == 'status' || $event.column.toLowerCase() == 'priority') {
      data[$event.column] = $event.entry.name;
    } else {
      if ($event.column && !$event.multiDropdown) {
        data[$event.column] = $event.entry;
      } else if ($event.column && $event.multiDropdown && $event.type == 'add') {
        data[$event.column] = [...data[$event.column], $event.entry];
      } else if ($event.column && $event.multiDropdown && $event.type == 'remove') {
        let entries = data[$event.column] || [];
        const index = _.findIndex(entries, {id: $event.entry.id});
        const assignedToIndex = _.findIndex(entries, {assignedTo: $event.entry.assignedTo});
        if (index !== -1) {
          entries = entries.filter((entry, idx) => {
            return index != idx;
          });
        } else if (assignedToIndex !== -1) {
          entries = entries.filter((entry, idx) => {
            return assignedToIndex != idx;
          });
        }
        data[$event.column] = entries;
      }
    }
    data.taskAssignees = this.getTpTaskAssignees(data.taskAssignees);
    this.trackerService.updateTaskForTracker(data, data.id)
      .subscribe(response => {
        if (this.trackerView !== 'info') {
          this.getTaskCount();
        }
        const index = _.findIndex(this.tableData.rows, {id: data.id});
        if (index !== -1) {
          const rows = this.tableData.rows || [];
          rows[index] = this.createTableRow(response);
          this.tableData = {...this.tableData, rows};
        }

        this.toastService.pop(TOAST_TYPE.success, 'Task Updated Successfully');
      }, error => {
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Task');
      });
  }

  getTpTaskAssignees(asignees) {
    let data = [];
    if (asignees && asignees.length > 0) {
      _.each(asignees, function(item) {
        if (!item['assignedTo']){
          item['assignedTo'] = item.id;
        }
      });
      data = _.uniqBy(asignees, 'assignedTo');
    }
    return data;
  }

  getTaskCount(search?) {
  }

  createTableRow(task) {
    const base = this;
    const row: any = {};
    const tooltipClass = base.getTooltipHtmlClass();
    _.each(task, function(value, key) {
      if (key == 'customerName') {
        row[key] = `<a class='actionOnId' data-action='edit'><span class='icon badge-tooltip title-name'>${base.setClientTitleString(task)}<span class='${tooltipClass} clientTooltip'>${task.toolTipData}</span></span></a>`;
        row.name = task[key];
      } else if(key == 'taskAssignees') {
        let data = [];
        if(task[key] && task[key].length > 0) {
          _.each(task[key], function(user){
            const obj = _.find(base.users, {id: user.assignedTo});
            if(obj) {
              obj['assignedTo'] = obj.id;
              obj['badge'] = obj.firstName.charAt(0) + obj.lastName.charAt(0);
              data.push(obj);
            }
          });
        }
        row[key] = _.uniqBy(data, 'assignedTo');
      } else if (key == 'status') {
        const obj = _.find(base.preferredStatuses, {id: task[key]});
        if (obj) {
          row[key] = obj;
        } else {
          row[key] = {id: task[key], name: task[key]};
        }
      }else if (key == 'priority') {
        if (task[key]) {
          row[key] = base.getPriorityBadge(task[key]);
        }
      } else {
        row[key] = task[key];
      }
    });
    row.statusColorCode = row.pastDueFlag ? '#f1645a' : row.statusColorCode;
    row.actions = '';
    row.isEditable = true;
    return row;
  }

  getTooltipHtmlClass() {
    return this.tableData.rows && this.tableData.rows.length == 0 ? 'bottomTooltiptext' : 'topTooltiptext';
  }

  getPriorityBadge(priority) {
    if (priority) {
      return _.find(this.priorities, {name: priority});
    }
    return false;
  }

  setClientTitleString(task) {
    if (task && task.customerName && task.customerName.length > 25) {
      return task.customerName.substring(0, 25) + '...';
    } else {
      return task.customerName;
    }
  }

  updateInput(obj) {
    let task = _.find(this.trackerData, {id: obj.row.id});
    if (task) {
      if (task[obj.column]) {
        task[obj.column] = obj.row[obj.column];
      }
      task.taskAssignees = this.getTpTaskAssignees(task.taskAssignees);
      this.trackerService.updateTaskForTracker(task, task.id)
        .subscribe(response => {
          if (this.trackerView !== 'info') {
            this.getTaskCount();
          }
          const index = _.findIndex(this.tableData.rows, {id: task.id});
          if (index !== -1) {
            const rows = this.tableData.rows || [];
            rows[index] = this.createTableRow(response);
            this.tableData = {...this.tableData, rows};
          }
          this.toastService.pop(TOAST_TYPE.success, 'Task Updated Successfully');
        }, error => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Task');
        });
    }
  }

  moveNextStatus($event) {
    const data = _.find(this.trackerData, {taskId: $event.row.taskId});
    data.status = $event.row.status ? $event.row.status.id : data.status;
    this.trackerService.updateTaskStatusOrder(data, $event.row.taskId)
      .subscribe(response => {
        if (this.trackerView !== 'info') {
          this.getTaskCount();
        }
        const index = _.findIndex(this.tableData.rows, {id: $event.row.id});
        if (index !== -1) {
          const rows = this.tableData.rows || [];
          rows[index] = this.createTableRow(response);
          data.status = response.status;
          this.tableData = {...this.tableData, rows};
        }
        this.toastService.pop(TOAST_TYPE.success, `${$event.column.charAt(0).toUpperCase() + $event.column.slice(1)} Updated Successfully`);
      }, error => {

        const message = error.message ? error.message : `Failed To Update ${$event.column.charAt(0).toUpperCase() + $event.column.slice(1)}`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  addTodo() {
    this.todoAssignees = [];
    this.todoId = uuid();
    this.attachments = [];
    // this.todoAssignees = [...this.externalUsers];
    this.reveal = {...this.reveal, addTodo: true};
    this.changeDetectorRef.detectChanges();
  }

  hideReveal(revealFlag) {
    this.reveal[revealFlag] = false;
    if (revealFlag === 'addTodo') {
      this.resetTodoData();
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  resetTodoData() {
    this.todoTitle = '';
    this.todoDesc = '';
    this.todoDuedate = '';
    this.todoPriority = 'Medium';
    this.selectedTaxStrategyTodo = '';
    this.todoAssignees = [];
  }

  setTaxStrategyTodo($event) {
    this.selectedTaxStrategyTodo = $event.id;
    this.todoTitle = $event.name || '';
    this.todoDesc = $event.description || '';
  }

  setDueDate(date) {
    this.todoDuedate = date;
  }

  setPriority($event) {
    const base = this;
    if (!_.isEmpty($event)) {
      this.todoPriority = $event.id;
    } else {
      this.todoPriority = 'Medium';
    }
  }

  setFileUploader() {
    const base = this;
    const docUrl: any = this.taxStrategyServices.getDocumentServiceUrl(this.org, this.user);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);

    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.todoId;
      payload.sourceType = 'TODO_ATTACHMENT';
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploader.progress = 100;
        this.uploader.queue.forEach(function(_item) {
          if (item._file.name === _item._file.name) {
            _item.remove();
          }
        });
        this.document = JSON.parse(response);
        this.compileLink();
      }
    };
  }

  compileLink() {
    const base = this;
    if (this.document && this.document.temporaryURL) {
      const data = {
        id: this.document.id,
        name: this.document.name,
        temporaryURL: this.document.temporaryURL
      };
      base.attachments.push(data);
    }
  }

  startUpload($event) {
    const base = this;
    setTimeout(function() {
      base.uploader.uploadAll();
    }, 1000);
  }

  removeUploadItem(item) {
    item.remove();
  }

  downloadDocument(fileId, type?) {
    if (fileId) {
      this.loadingService.triggerLoadingEvent(true);
      this.taxStrategyServices.downloadDocument(Session.getUser().id, this.org, fileId)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          if (type === 'download') {
            window.open(response.temporaryURL);
          } else {
            window.open(response.viewDocContentURL);
          }
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          const errorMessage = 'Failed to download document';
          this.toastService.pop(TOAST_TYPE.error, errorMessage);
        });
    }
  }

  removeAttachment(attachment) {
  }

  createTodo() {
    const data: any = {
      id: this.todoId,
      taskId: this.singlePageTaskData[0].taskId,
      companyId: this.singlePageTaskData[0].company_id,
      dueDate: this.todoDuedate,
      title: this.todoTitle,
      description: this.todoDesc,
      priority: this.todoPriority,
      recurring: 'Never'
    };
    data.clientId = this.channelId;
    if (this.attachments.length > 0) {
      data.documents = this.attachments;
      _.forEach(data.documents, function(data) {
        delete data.temporaryURL;
      });
    }
    this.loadingService.triggerLoadingEvent(true);
    this.resetTodoTable = false;
    this.trackerService.addSinglePageTodo(this.org, this.user, this.taskId, data)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.resetTodoTable = true;
        response.description = (response.description) ? response.description : this.todoDesc;
        this.todoData.toDosList.push(response);
        this.resetTodoData();
        this.hideReveal('addTodo');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.resetTodoTable = true;
        const message = error.message || 'Failed To Add ToDo';
        this.toastService.pop(TOAST_TYPE.error, message);
      });
  }

   navigateToCreateTodo($event) {
        const checkList = $event;
        this.todoTitle = (checkList && checkList.name) ? checkList.name : '';
        this.todoDesc = (checkList && checkList.description) ? checkList.description : '';
        this.addTodo();
    }

}
